import {SalesPerson} from "sharedlibs";
import {createBusinessAuditLog} from "../api/auditlog";
import KeycloakService from "../KeycloakService";

/**
 * Business audit message for saving an edited salesperson: a save that only switches the
 * status is logged as deactivated or reactivated. A save that also changes the last name
 * is logged as updated, so the rename is not hidden; its prev/new values show the status.
 */
export function salesPersonUpdateAuditMessage(before: SalesPerson, after: SalesPerson): string {
  if (before.lastName === after.lastName) {
    if (!before.disabled && after.disabled) return 'audit.salesPerson.deactivated'
    if (before.disabled && !after.disabled) return 'audit.salesPerson.reactivated'
  }
  return 'audit.salesPerson.updated'
}

/**
 * Logs a business audit event. Captures username and userRole from Keycloak automatically.
 * prevValue and newValue are serialized to JSON strings.
 */
export async function logBusinessAudit(
  message: string,
  customerId: string,
  prevValue: unknown,
  newValue: unknown,
): Promise<void> {
  try {
    const kc = KeycloakService.instance;
    const username = kc.getUsername?.() ?? 'unknown';
    const userRole = kc.getClientRoles?.().join(', ') ?? 'unknown';

    await createBusinessAuditLog({
      customerId,
      message,
      username,
      userRole,
      prevValue: prevValue != null ? JSON.stringify(prevValue) : '',
      newValue: newValue != null ? JSON.stringify(newValue) : '',
    });
  } catch (e) {
    console.error('Failed to create business audit log:', e);
  }
}
